import cn from 'classnames';
import React from 'react';

import getSwatchBackground from 'editor/src/util/color/getSwatchBackground';

import IconCheck2 from 'editor/src/component/Icon/IconCheck2';
import IconNoColor from 'editor/src/component/Icon/IconNoColor';

import Unavailable from './Unavailable';

import styles from './index.module.scss';

interface Props {
  colorHex?: string;
  selected: boolean;
  toggle?: (selected: boolean) => void;
  disabled?: boolean;
  texture?: string;
  className?: string;
}

const ColorDot = React.memo(({ texture, colorHex, selected, disabled, toggle, className }: Props) => {
  const backgroundStyle = getSwatchBackground(colorHex, texture);

  const handleClick = () => {
    if (!disabled && toggle) {
      toggle(!selected);
    }
  };

  return (
    <div
      className={cn(
        styles.colorDot,
        {
          [styles.selected]: selected,
          'cy-active': selected,
          [styles.disabled]: disabled,
        },
        className,
      )}
      onClick={handleClick}
    >
      {!!(backgroundStyle.backgroundImage || backgroundStyle.backgroundColor) && (
        <div style={backgroundStyle} className={styles.color} />
      )}
      {!colorHex && !texture && <IconNoColor />}
      {selected && <IconCheck2 className={styles.icon} />}
      {disabled && <Unavailable className={styles.unavailable} />}
    </div>
  );
});

export default React.memo(ColorDot);
